import { assert_string_not_empty, assert_type_boolean, assert_type_number } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '../../../../serialization/ENUM__dto_class_name';
import { DTO__entity_with_grid2d } from './DTO__entity_with_grid2d';

export class DTO__workspace_child_enity extends DTO__entity_with_grid2d {
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_CHILD_ENTITY;

  /*
   * STATIC METHODS
   */
  static get_key(type: string, id: string) {
    return `${type}_${id}`;
  }

  static sort_by_sharing_started_at(a: DTO__workspace_child_enity, b: DTO__workspace_child_enity) {
    return b.sharing_started_at - a.sharing_started_at;
  }

  /*
   * FIELDS
   */
  is_hidden!: boolean;
  is_shared!: boolean;
  sharing_started_at!: number;
  user_id_shared_by!: string; //optinal

  /*
   *  METHODS
   */

  constructor() {
    super();
    this.is_hidden = false;
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.name); //required for all entities

    assert_type_boolean(this.is_hidden);
    assert_type_boolean(this.is_shared);
    assert_type_number(this.sharing_started_at);
  }
}
